/* trademarks: the portfolio list (`tm`), one trademark's dossier (`tmd`) and
 * the add form (`tmAdd`) — translated in the Wave 3 pass (2026-09-30). */
export default {
  tm: {
    title: 'Meine Marken',
    subtitle:
      'Überwachte Marken, Rechtsgebiete, Rechtsstand und Überwachungsaktivität an einem Ort verwalten.',
    filters: 'Filter',
    add: 'Marke hinzufügen',
    kpi: {
      label: 'Überblick über das Portfolio',
      total: 'Marken insgesamt',
      thisMonth: 'in diesem Monat',
      noneThisMonth: 'In diesem Monat keine hinzugefügt',
      monitored: 'Aktive Überwachung',
      ofPortfolio: 'des Portfolios überwacht',
      openMatches: 'Treffer zur Prüfung',
      openMatchesHint: 'Im gesamten Portfolio',
      openMatchesNone: 'Nichts offen',
      registries: 'Abgedeckte Register',
      registriesNone: 'Keine Überwachung eingerichtet',
    },
    filter: {
      search: 'Suche',
      searchPlaceholder: 'Marke oder Inhaber',
      monitoring: 'Überwachungsstatus',
      monitored: 'Überwacht',
      notMonitored: 'Nicht überwacht',
      registry: 'Register',
      noRegistries: 'Noch keine Register eingerichtet.',
      classes: 'Nizza-Klassen',
      classesHint: 'Klassen auf dieser Seite, die häufigsten zuerst.',
      type: 'Markenform',
      reset: 'Zurücksetzen',
      apply: 'Anwenden',
    },
    chip: {
      registry: 'Register: {code}',
      class: 'Klasse {n}',
      search: 'Suche: {q}',
    },
    sort: {
      label: 'Marken sortieren',
      title: 'Name (A–Z)',
      titleDesc: 'Name (Z–A)',
      recent: 'Zuletzt hinzugefügt',
      registered: 'Eintragungsdatum, neueste zuerst',
      expiring: 'Ablaufdatum, früheste zuerst',
    },
    bulk: {
      confirmTitle: '{n} Marke löschen? | {n} Marken löschen?',
      cannotUndo: 'Das kann nicht rückgängig gemacht werden.',
      goesWith: 'Überwachungsumfang, Dokumente und Trefferverlauf werden mit gelöscht.',
      partial: '{done} von {n} gelöscht',
      partialSub: '{n} konnte nicht gelöscht werden. | {n} konnten nicht gelöscht werden.',
      done: '{n} Marke gelöscht | {n} Marken gelöscht',
    },
    shown: '{n} von {total} Marke | {n} von {total} Marken',
    filtersActive: '{n} Filter aktiv | {n} Filter aktiv',
    searchPlaceholder: 'Marken suchen…',
    col: {
      trademark: 'Marke',
      owner: 'Inhaber',
      juris: 'Land',
      classes: 'Klassen',
      monitoring: 'Überwachung',
      status: 'Status',
      review: 'Prüfung',
    },
    empty: {
      title: 'Keine Marke entspricht Ihren Filtern',
      message:
        'Heben Sie die Auswahl von Register oder Klasse auf oder suchen Sie nach einem anderen Namen.',
      reset: 'Filter zurücksetzen',
    },
    page: {
      showing: 'Angezeigt:',
      ofTotal: 'von {total} Marke | von {total} Marken',
      prev: 'Vorherige Seite',
      next: 'Nächste Seite',
    },
    preview: {
      label: 'Vorschau der ausgewählten Marke',
      noNumber: 'Ohne Nummer',
      reg: 'Eingetr. {date}',
      close: 'Vorschau schließen',
      owner: 'Inhaber',
      country: 'Land',
      watchedOn: 'Überwacht in',
      pausedOn: 'Pausiert: {list}',
      classes: 'Nizza-Klassen',
      type: 'Markenform',
      status: 'Status',
      monitoring: 'Überwachung',
      awaiting: 'Treffer wartet auf Prüfung | Treffer warten auf Prüfung',
      openCases: '{n} offenes Verfahren | {n} offene Verfahren',
      dossier: 'Vollständige Akte öffnen',
      openMonitoring: 'Zur Überwachung',
    },
    monitoring: {
      active: 'Aktive Überwachung',
      paused: 'Überwachung pausiert',
      none: 'Nicht überwacht',
    },
    monitoringTag: {
      active: 'Aktiv',
      paused: 'Pausiert',
      none: 'Nicht überwacht',
    },
    row: {
      select: '{name} auswählen',
      logoAlt: 'Logo von {name}',
      toReview: '{n} zu prüfen',
      clear: 'Keine',
      open: 'Markenakte öffnen',
    },
    status: {
      registered: 'Eingetragen',
      pending: 'Angemeldet',
      opposition: 'Widerspruch',
      under_review: 'In Prüfung',
      filed: 'Angemeldet',
      published: 'Veröffentlicht',
      opposed: 'Widerspruch erhoben',
      cancellation_procedure: 'Löschungsverfahren',
      expired: 'Abgelaufen',
      refused: 'Zurückgewiesen',
      withdrawn: 'Zurückgenommen',
    },
    type: {
      wordmark: 'Wortmarke',
      figurative: 'Bildmarke',
      combined: 'Wort-Bild-Marke',
      sound: 'Hörmarke',
      other: 'Sonstige',
    },
  },

  tmd: {
    back: 'Zurück zum Portfolio',
    logoAlt: 'Logo von {name}',
    eyebrow: 'Geschützte Marke',
    toReviewTitle: 'Von der KI gefundene Treffer, die noch niemand geprüft hat',
    regShort: 'Eingetr.',
    monitoring: 'KI-Überwachung',
    monitoringActive: 'Aktiv · {list}',
    uploading: 'Wird hochgeladen…',
    upload: 'Dokument hochladen',
    openMonitoring: 'Zur Überwachung',
    createOpposition: 'Widerspruchsverfahren anlegen',
    label: 'Markenakte',
    sections: 'Abschnitte der Akte',
    tab: {
      overview: 'Überblick',
      monitoring: 'Überwachung',
      matches: 'Treffer',
      oppositions: 'Widersprüche',
      documents: 'Dokumente',
    },
    details: {
      title: 'Eintragungsdaten',
      type: 'Markenform',
      country: 'Land der Eintragung',
      number: 'Eintragungs- oder Anmeldenummer',
      status: 'Status',
      filed: 'Angemeldet',
      registered: 'Eingetragen',
      expires: 'Läuft ab',
      owner: 'Inhaber',
      classes: 'Nizza-Klassen',
      description: 'Beschreibung',
    },
    scopes: {
      title: 'Überwachungsumfang',
      count: '{n} Register | {n} Register',
      emptyTitle: 'Diese Marke wird nicht überwacht',
      empty:
        'Für diese Marke ist kein Register ausgewählt, daher werden neue Veröffentlichungen nicht mit ihr verglichen.',
      registry: 'Register',
      state: 'Zustand',
      lastScan: 'Zuletzt geprüft',
      active: 'Aktiv',
      paused: 'Pausiert',
      awaiting: 'Wartet auf die erste Prüfung (drei Monate rückwirkend)',
      never: 'Nie geprüft',
      feedFallback: 'Quelle {id}',
    },
    matches: {
      title: 'Zugehörige Treffer',
      awaiting: '{n} zu prüfen',
      found: 'Gefundene Marke',
      registry: 'Register',
      decidedBy: 'Entschieden von',
      risk: 'Risiko',
      window: 'Frist',
      rule: 'Regeltreffer',
      review: 'Prüfen',
      emptyTitle: 'Keine Treffer für diese Marke',
      empty:
        'In den überwachten Registern wurde bisher nichts veröffentlicht, das dieser Marke ähnlich ist.',
      more: 'Angezeigt werden die {n} mit der nächsten Widerspruchsfrist. Die übrigen stehen auf der Überwachungsseite unter dieser Marke.',
      closesToday: 'Endet heute',
      closedDays: 'Seit {n} Tag abgelaufen | Seit {n} Tagen abgelaufen',
      closedMonths: 'Seit {n} Monat abgelaufen | Seit {n} Monaten abgelaufen',
      closedYears: 'Seit {n} Jahr abgelaufen | Seit {n} Jahren abgelaufen',
    },
    docs: {
      title: 'Dokumente',
      count: '{n} Datei | {n} Dateien',
      emptyTitle: 'Noch keine Dokumente',
      empty: 'Hier liegen Eintragungsurkunden, Benutzungsnachweise und Korrespondenz.',
      uploadFirst: 'Datei hochladen',
      file: 'Datei',
      kind: 'Art',
      size: 'Größe',
      added: 'Hinzugefügt',
      remove: '{name} löschen',
      rejected: 'abgelehnt',
      notUploaded: '{n} Datei nicht hochgeladen | {n} Dateien nicht hochgeladen',
      uploaded: '{n} Datei hochgeladen | {n} Dateien hochgeladen',
      confirmTitle: '{name} löschen?',
      confirmBody: 'Die Datei wird endgültig gelöscht. Das kann nicht rückgängig gemacht werden.',
      deleted: 'Datei gelöscht',
      deleteFailed: 'Die Datei konnte nicht gelöscht werden',
    },
    rail: {
      label: 'Schutzübersicht',
      title: 'Schutzübersicht',
      watchedOn: 'Überwacht in',
      none: 'Keine',
      classes: 'Nizza-Klassen',
      noneRecorded: 'Keine erfasst',
      toReview: 'Treffer zur Prüfung',
      openCases: 'Offene Verfahren',
    },
  },

  tmAdd: {
    crumb: 'Marke hinzufügen',
    title: 'Marke hinzufügen',
    subtitle:
      'Erfassen Sie eine Marke, die Sie schützen, und wählen Sie, welche Register auf Kollisionen überwacht werden.',
    creating: 'Wird angelegt…',
    create: 'Marke anlegen',
    loadFailed: 'Konnte nicht geladen werden: {list}.',
    failedPart: {
      clients: 'Mandanten',
      registries: 'Register',
      classes: 'Nizza-Klassen',
    },
    workspace: 'Formular für eine neue Marke',
    required: 'Pflichtangaben',
    example: 'z. B. {value}',
    err: {
      title: 'Der Markenname ist erforderlich',
      titleShort: 'Mindestens {n} Zeichen',
      client: 'Wählen Sie den Mandanten, dem die Marke gehört',
      country: 'Das Land der Eintragung ist erforderlich',
      type: 'Wählen Sie eine Markenform',
      classes: 'Wählen Sie mindestens eine Nizza-Klasse',
      incomplete: 'Bitte füllen Sie die Pflichtfelder aus',
    },
    mark: {
      title: 'Die Marke',
      sub: 'Was geschützt wird und wem es gehört.',
      name: 'Markenname',
      namePlaceholder: 'Die Marke wie angemeldet',
      country: 'Land der Eintragung',
      countryPick: 'Land wählen…',
      countryHint: 'Bestimmt, welches nationale Register überwacht werden darf.',
      owner: 'Inhaber (Mandant)',
      ownerPick: 'Mandanten wählen…',
      clientCount: '{n} Mandant in Ihrem Arbeitsbereich | {n} Mandanten in Ihrem Arbeitsbereich',
      addClient: 'neuen anlegen',
      type: 'Markenform',
      description: 'Beschreibung',
      descriptionPlaceholder:
        'Waren und Dienstleistungen in eigenen Worten oder alles, was die nächste Person wissen sollte.',
    },
    typeHint: {
      word: 'Nur Text – geschützt ist der Name selbst.',
      figurative: 'Ein Logo oder Bildzeichen ohne Wortbestandteil.',
      combined: 'Wort- und Bildbestandteile zusammen.',
      sound: 'Ein Jingle oder eine akustische Signatur.',
      other: 'Form, Farbe, Bewegung, Position.',
    },
    registration: {
      title: 'Eintragung',
      sub: 'Optional – eine Marke kann schon vor der Eintragung überwacht werden.',
      application: 'Anmeldenummer',
      registration: 'Eintragungsnummer',
      filed: 'Angemeldet am',
      registered: 'Eingetragen am',
      expires: 'Läuft ab am',
    },
    scopes: {
      title: 'Wo überwachen',
      sub: 'Jedes ausgewählte Register wird auf Kollisionen mit dieser Marke geprüft.',
      selected: '{n} ausgewählt',
      hint: 'Eine Marke ohne ausgewähltes Register wird gespeichert, aber nie geprüft.',
      inactive: 'Derzeit nicht aktiv',
      countryFirst: 'Zuerst das Land wählen',
      onlyFor: 'Nur für Marken aus {code}',
      noSource: 'Ihre Kanzlei hat für dieses Register keine Quelle eingerichtet',
    },
    feedKind: {
      world: 'International (Madrider System)',
      europe: 'Europäische Union',
      national: 'Nationales Amt',
    },
    classes: {
      title: 'Nizza-Klassen',
      sub: 'Die Waren und Dienstleistungen, die die Marke abdeckt. Kollisionen werden innerhalb dieser Klassen beurteilt.',
      search: 'Alle 45 Klassen nach Nummer oder Wortlaut durchsuchen…',
      searchLabel: 'Nizza-Klassen durchsuchen',
    },
    next: {
      label: 'Hinweise',
      title: 'Wie es weitergeht',
      now: 'Sofort.',
      nowText: 'Die Marke wird ihrem Mandanten zugeordnet und erscheint im Portfolio.',
      scan: 'Erste Prüfung.',
      scanText:
        'Jeder neue Überwachungsumfang beginnt mit einer Prüfung der letzten drei Monate – der Widerspruchsfrist –, damit nichts bereits Veröffentlichtes übersehen wird.',
      after: 'Danach.',
      afterText:
        'Laden Sie die Eintragungsurkunde und etwaige Nachweise in der Akte der Marke hoch.',
    },
    actions: 'Formularaktionen',
    unsaved: 'Es wird nichts gespeichert, bevor Sie die Marke anlegen.',
    created: 'Marke angelegt',
    createdWatched:
      '{name} wird jetzt in {n} Register überwacht. | {name} wird jetzt in {n} Registern überwacht.',
    createdUnwatched: '{name} wurde hinzugefügt. Noch kein Überwachungsumfang ausgewählt.',
    createFailed: 'Die Marke konnte nicht angelegt werden',
  },
} as const
